import React, { ForwardRefRenderFunction } from 'react';

export function acidForwardRef<T, P = {}>(
  render: ForwardRefRenderFunction<T, P>,
):React.FunctionComponent<P & React.RefAttributes<T>> {
  // @ts-ignore
  return React.forwardRef<T, P>(render);
}
